import { useState } from "react";
import { Box, Button, Tooltip } from "@mui/material";
import { Search, FileText } from "lucide-react";

export default function ToggleButton({ onChange, component }) {
  const [selected, setSelected] = useState(
    component === "case" ? "keyword" : "Title"
  );

  const handleToggle = (newValue) => {
    setSelected(newValue);
    onChange?.(newValue);
  };

  // Define the options based on component type
  const getOptions = () => {
    if (component === "case") {
      return [
        {
          label: "Keyword",
          value: "keyword",
          icon: <FileText size={18} color="#8B5CF6" />,
          color: "#8B5CF6",
          hoverColor: "#7C3AED",
          tooltip: "Search by keywords and phrases",
        },
        {
          label: "AI Search",
          value: "vector",
          icon: <Search size={18} color="#F59E0B" />,
          color: "#F59E0B",
          hoverColor: "#D97706",
          tooltip: "AI-powered semantic search",
        },
      ];
    } else {
      return [
        {
          label: "Title",
          value: "Title",
          icon: <FileText size={18} color="#2563EB" />,
          color: "#2563EB",
          hoverColor: "#1D4ED8",
          tooltip: "Search by statute title",
        },
        {
          label: "Section",
          value: "Section",
          icon: <Search size={18} color="#059669" />,
          color: "#059669",
          hoverColor: "#047857",
          tooltip: "Search by statute content",
        },
      ];
    }
  };

  const options = getOptions();

  return (
    <Box
      sx={{
        display: "flex",
        gap: "8px",
        flexShrink: 0,
      }}
    >
      {options.map((option, index) => (
        <Tooltip
          key={index}
          title={option.tooltip}
          arrow
          placement="bottom"
          enterDelay={400}
        >
          <Button
            variant="outlined"
            size="medium"
            startIcon={option.icon}
            onClick={() => handleToggle(option.value)}
            sx={{
              height: "48px",
              padding: "12px 16px",
              fontSize: "14px",
              fontWeight: 500,
              textTransform: "none",
              borderRadius: "12px",
              backgroundColor: selected === option.value ? `${option.color}15` : "transparent",
              color: selected === option.value ? option.color : "#6B7280",
              border: selected === option.value ? `1px solid ${option.color}` : "1px solid #E5E7EB",
              transition: "all 0.2s ease-in-out",
              "&:hover": {
                backgroundColor: selected === option.value ? `${option.color}25` : "#F9FAFB",
                borderColor: selected === option.value ? option.hoverColor : "#D1D5DB",
                transform: "scale(1.02)",
              },
              "& .MuiButton-startIcon": {
                marginRight: "6px",
              },
            }}
          >
            {option.label}
          </Button>
        </Tooltip>
      ))}
    </Box>
  );
}
